import React from "react";
import { useEffect, useState } from "react";
import "./styles.css";
import $ from "jquery";
import {closeDialog, showCustomDialog,showErrorDialog , confirmDialog, showSuccessDialog,
 Button , showLoading , Util} from 'baziigram'
import {STORAGE_KEY,dictionary} from "../../constants";
import {UpdateUser,GetUser} from "../../Util/user";
import {showLoginDialog} from "../../pages/Login"
import appService from '../../Service'
import {lifeStoneDictionary} from "../../constants/lifeStone.js";

   export const init = (gameId  ,callback=()=>{}) => {
             let user = GetUser()

             if($.connection && $.connection.state=="Connected")
             {
             callback(1)
             $.connection.invoke('getGroupInfo' ).then(res=> {
                  }).catch( error=> {
              showErrorDialog(error.data ? error.data.message: error.message)
                 });
             return
             }

         else if(!$.connection){
        $.connection = new window.signalR.HubConnectionBuilder()
         .withUrl(`${process.env.SIGNALR_URL}/Game/signalr/lifeStoneHub?gameId=${gameId}&language=${Util.getLanguage()}`,
         { accessTokenFactory: () => user.accessToken  })
        .build();
        }

         $.connection.onreconnected(connectionId => {
             callback(1)
             $.connection.invoke('getGroupInfo' ).then(res=> {
              }).catch( error=> {
              showErrorDialog(error.data ? error.data.message: error.message)
              });
              });
         $.connection.onreconnecting(error => {
             callback(0);
         });
          $.connection.onclose( () => {
            callback(0);
             setTimeout(()=>connectToHub(gameId,callback,7),3000)
             });

       try{

       	$.connection.on("initialize", (group,role,cId)=>initialize(group,role,cId));
       	$.connection.on("showNotif", (msg)=>receiveMessage(msg));
       	$.connection.on("requestToSync", (groupName , gameId)=>syncGroup(groupName , gameId));
       	$.connection.on("sync", (key , groupName , gameId)=>sync(key , groupName , gameId));
       	$.connection.on("receiveMessages", (groupName,  gameId,  messages, lastUpdate)=>
       	receiveMessages(groupName,  gameId,  messages, lastUpdate));

       	if(!$.connection || $.connection.state=="Disconnected")
     	connectToHub(gameId,callback)
       	}
       	catch(error){
       	callback(0)}
       	}


export const connectToHub=(gameId , callback=()=>{} , retry=7)=>
{

	 return $.connection.start({ waitForPageLoad: false }).then(res=>{
           callback(1)

	  }).catch(err=>{
	  if(callback)
	  callback(0)

	  if(err.message == "401")
	 showLoginDialog()

     $.connection.stop().then(res=>{
       $.connection=null;
       callback(0)
       }).catch(err=>{
       setTimeout(()=>init(gameId,callback),3000)
       })

	 })

}

export const disconnect=( )=>{
 $.connection.stop()

}

function initialize(group,role,cId)
{

let info = group

if(cId!=null)
info.cId=cId

if(role != null)
info.role = role


 window.dispatchEvent(
        new CustomEvent("connectToHub", {
            detail: info,
        })
    );


}


export const receiveMessage=(message)=>
{
window.dispatchEvent(
        new CustomEvent("receiveMessage", {
            detail: { message },
        })
    );

}


export const getGroupsList=(gameId)=>{
let language = Util.getLanguage();
let dir = language=="fa"?"rtl":"ltr"
showLoading(true)
appService.GetGroups(gameId).then(res=>{
let body = <div style={{lineHeight:"30px"}} className={'d-flex flex-column align-items-center justify-content-between'}>
      <div className={"d-flex flex-row justify-content-between w-100"}>
        <button
            type="button"
            className="close"
            onClick={()=>{closeDialog();
             }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
       {res.list.length==0 && <p className={dir}>{dictionary.noGroup[language]}</p>}
     {res.list.length>0  && res.list.map(room=>{
     return <div className={"d-flex flex-row justify-content-between align-items-center w-100 my-2"}>
                  <div className={"d-flex flex-row justify-content-start align-items-center"}>
                         <img className="room-flag" src={`/images/Group/flags/${room.flag}.png`}/>
                         <p>{room.groupName}</p>
                   </div>
                   <Button className="mx-0" onClick={()=>{requestToJoin(room.groupName);}} title={dictionary.join[language]}></Button>
              </div>
     })
      }

    </div>

    showCustomDialog(body)

}).catch(err=>{
showErrorDialog(err.message)
}).finally(res=>{
showLoading(false)
})

}


export const getJoinRequests=(gameId , groupName)=>{
let language = Util.getLanguage();
let dir = language=="fa"?"rtl":"ltr"
showLoading(true)
appService.GetJoinRequests(gameId,groupName).then(res=>{
let body = <div style={{lineHeight:"30px"}} className={'d-flex flex-column align-items-center justify-content-between'}>
      <div className={"d-flex flex-row justify-content-between w-100"}>
        <button
            type="button"
            className="close"
            onClick={()=>{closeDialog();
             }}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      {res.list.length==0 && <p className={dir}>{dictionary.noJoinRequest[language]}</p>}
     {res.list.length>0 && res.list.map(request=>{
     return <div id={`request-${request.id}`} className={`d-flex flex-row justify-content-between align-items-center w-100 my-2 ${dir}`}>
                  <div className={`d-flex flex-row justify-content-start align-items-center ${dir}`}>
                         <img className="room-flag" src={`/images/profileImages/${request.logo}.png`}/>
                         <p className={dir}>{request.name}</p>
                   </div>
                   <div className={`d-flex flex-row justify-content-between ${dir}`}>
                  <Button className="ml-1 acceptBtn" onClick={()=>{acceptJoinRequest(request.id,groupName,gameId)}} title={dictionary.accept[language]}></Button>
              <Button className="mr-1 baziigramSecondaryBtn acceptBtn" onClick={()=>{rejectJoinRequest(request.id,groupName,gameId)}} title={dictionary.reject[language]}></Button>
                    </div>
              </div>
     })
      }

    </div>

    showCustomDialog(body)

}).catch(err=>{
showErrorDialog(err.message)
}).finally(res=>{
showLoading(false)
})

}

export const confirmLeaveGroup=(gameId , groupName)=>{
const language = Util.getLanguage();
const txt = language == "fa" ? ` آیا  میخواهید از گروه  ${groupName} خارج شوید؟ ` : `Do you want to exit ${groupName}?`
let actions = [
           { title: dictionary.no[language], className: "baziigram-secondary-btn", action: null },
           {
               title: dictionary.yes[language],
               className: "baziigram-ok-btn",
               action: () => leaveGroup(gameId , groupName),
           },
       ];
       confirmDialog(
           txt,
           actions
       );
}

export const leaveGroup=(gameId , groupName)=>{
let language = Util.getLanguage();
	$.connection.invoke('LeaveRoom' ).then(res=>{
	showSuccessDialog(dictionary.leaveGroup[language])
	let u=GetUser()
     delete u[groupName+"-"+gameId]
     UpdateUser(u)
         window.dispatchEvent(
           new CustomEvent("connectToHub", {detail: { name:null }})
                     );
    }).catch(error=> {
		showErrorDialog(error.data ? error.data.message : error.message)
		closeDialog();
        });
}


function requestToJoin(groupName)
{
let language = Util.getLanguage();
	$.connection.invoke('RequestToJoinGroup', groupName ).then(res=> {
       showSuccessDialog(dictionary.sendJoinRequest[language])
		closeDialog()
    }).catch(error=> {
		showErrorDialog(error.message)
        });
}


export const acceptJoinRequest=(requestId , groupName , gameId)=>
{
	$.connection.invoke('AcceptJoinRequest', requestId ).then(res=> {
		if(document.getElementById(`request-${requestId}`).parentNode.childElementCount==1)
		{
			closeDialog()
		}
		else
          document.getElementById(`request-${requestId}`).remove();

        syncGroup(groupName , gameId)

    }).catch( error=> {
    showErrorDialog(error.data ? error.data.message: error.message)
		 });
}

export const rejectJoinRequest=(requestId )=>
{
	$.connection.invoke('RejectJoinRequest', requestId ).then(res=> {
		if(document.getElementById(`request-${requestId}`).parentNode.childElementCount==1)
		{
			closeDialog()
		}
		else
          document.getElementById(`request-${requestId}`).remove();

    }).catch( error=> {
    showErrorDialog(error.data ? error.data.message: error.message)
		 });
}


 export const sync = (key , groupName , gameId )=>
{
 let user = GetUser()
user[groupName+"-"+gameId] = key
UpdateUser(user)
window.dispatchEvent(new CustomEvent("sync"));
}

export const sendMessageToGroup=(msg  , callback)=>{

$.connection.invoke('SendMessageToGroup',msg ).then(res=> {
    window.dispatchEvent(new CustomEvent("successfulSending"));
    }).catch( error=> {
showErrorDialog(error.data ? error.data.message: error.message)
		 });

}

export const requestToSync=(callback=()=>{})=>{
$.connection.invoke('requestToSync').then(res=> {
    }).catch( error=> {
     callback();
   // showErrorDialog(error.data ? error.data.message: error.message)
 });

}

export const syncGroup=( groupName , gameId)=>{

 const key = GetUser()[groupName+"-"+gameId]
 if(!key)
 return

    $.connection.invoke('sync', key ).then(res=> {
          }).catch( error=> {
      showErrorDialog(error.data ? error.data.message: error.message)
      	 });

}

export const syncMessages=(   chats , lastUpdate)=>{
    $.connection.invoke('syncMessages',  chats , lastUpdate).then(res=> {
          }).catch( error=> {
          showErrorDialog(error.data ? error.data.message: error.message)
      	 });

}

export const receiveMessages=(groupName,  gameId,  messages, lastUpdate)=>{
window.dispatchEvent(
        new CustomEvent("syncMessages", {
            detail: { messages ,  lastUpdate},
        })
    );
}